module.exports = __webpack_public_path__ + "static/media/BY.bdd5c349.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BY.svg
// module id = 214
// module chunks = 0